import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState, useEffect } from 'react';
export var useUserProfile = function useUserProfile() {
  var _useState = useState(false),
      isUserRegistered = _useState[0],
      setIsUserRegistered = _useState[1];

  var _useState2 = useState(true),
      isProfileLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var getUserProfile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('/api/v1/profile');

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              data = _context.sent;

              if (data.error || !data.state) {
                setIsUserRegistered(false);
              }

              if (data.state === 'REGISTERED') {
                setIsUserRegistered(true);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              setIsUserRegistered(false);

            case 14:
              _context.prev = 14;
              setIsLoading(false);
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11, 14, 17]]);
    }));

    return function getUserProfile() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getUserProfile();
  }, []);
  return {
    isUserRegistered: isUserRegistered,
    isProfileLoading: isProfileLoading
  };
};